import { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";
import type { StepRankRow } from "@/lib/types";

interface StepRankPreview {
  /** 오늘 참여 인원 */
  players: number;
  /** 상위 3명 (요청 limit=3) */
  rows: StepRankRow[];
}

/**
 * 비로그인 방문자용 «오늘 랭킹 맛보기».
 * step_rank.php 는 로그인 없이도 조회되므로 상위 3명만 가볍게 가져온다.
 * enabled 가 false 이면(로그인 상태) 호출하지 않는다.
 */
export function useStepRankPreview(enabled: boolean): StepRankPreview {
  const [players, setPlayers] = useState(0);
  const [rows, setRows] = useState<StepRankRow[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let active = true;

    apiGet<{ players?: number; list?: StepRankRow[] }>(
      "step_rank.php?period=today&limit=3"
    )
      .then((res) => {
        if (!active) return;
        setPlayers(Number(res.data?.players ?? 0));
        setRows((res.data?.list ?? []).slice(0, 3));
      })
      .catch(() => {
        // 맛보기 영역이라 실패해도 조용히 생략한다.
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { players, rows };
}